import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/classes/page';
import { AllotService } from 'src/app/services/Allot.service';
import { AuditService } from 'src/app/services/audit.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-raise-audit-request',
  templateUrl: './raise-audit-request.component.html',
  styleUrls: ['./raise-audit-request.component.scss'],
})
export class RaiseAuditRequestComponent implements OnInit {
  page = new Page();
  rows: any[] = [];
  columns: any[] = [];

  loading = false;
  upload = false;
  payment = false;
  hideDivs = true;

  errorMessage = '';

  filter: any = { iAuditorID: '', auditorname: '', keyword: '' };
  auditors: any[] = [];
  filteredRows: any[] = [];
  filteredData: any[] = [];
  auditorName: any[] = [];
  auditorID: any;
  filteredStatus: any;

  id: number | null = null;
  iAllotAuditorID: any;
  base64String = '';
  today: string = '';
  cd: any;

  constructor(
    private allotService: AllotService,
    private auditService: AuditService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.page.pageNumber = 1;
    this.page.pageSize = 10;
    this.page.totalRecords = 0;

    const now = new Date();
    this.today = now.toISOString().split('T')[0];
  }

  ngOnInit(): void {


    this.setPage({ offset: 0 });
  this.columns = [
  { prop: 'AuditRaisedDate', name: 'Audit Raised Date' },
  { prop: 'BlockName', name: 'Block Name' },
  { prop: 'SocietyName', name: 'Society Name' },
  { prop: 'AuditorName', name: 'Auditor Name' },
  { prop: 'AuditorMobile', name: 'Auditor Mobile' },
];

  }
  auditorData: any;
  allDataLoaded = false;

  search() {
    this.setPage({ offset: 0 });
  }
  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.loading = true;
    this.loadAuditorsFromApi();
    this.applyFiltersAndPagination();

  }
loadAuditorsFromApi() {
  this.loading = true;
  const requestParams = {
    pageSize: this.page.pageSize,
    pageNumber: this.page.pageNumber,
    filter: {
      auditorName: this.filter.auditorName ?? '',
      keyword: this.filter.keyword ?? ''
    }
  };
  

  this.allotService.getRaiseAudit(requestParams).subscribe({
    next: (response) => {
      this.loading = false;

      if (response.status === 200) {
        this.rows = response.data.map((item: any) => ({
          ...item,
          AuditRaisedDate: this.formatDate(item.AuditRaisedDate)
        }));

        this.page.totalRecords = response.totalRecords || this.rows.length; 

      } else {
        this.rows = [];
        this.page.totalRecords = 0;
      }
    },
    error: (error) => {
      this.loading = false;
    }
  });
}

  onRowsPerPageChange() {
    this.page.pageNumber = 0;
    this.setPage({ offset: 0 });
  }
  applyFiltersAndPagination() {
    this.filteredRows = this.rows.filter(item => {
      const auditorNameMatch = !this.filter.auditorName || item.auditorName?.toLowerCase().includes(this.filter.auditorName.toLowerCase());
      const keywordMatch = !this.filter.keyword || item.name?.toLowerCase().includes(this.filter.keyword.toLowerCase()) || item.mobile?.includes(this.filter.keyword);

      return auditorNameMatch && keywordMatch;
    });

    const start = this.page.pageNumber * this.page.pageSize;
    const end = start + this.page.pageSize;
    this.filteredRows = this.filteredRows.slice(start, end);
  }
  formatDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return `${date.getDate().toString().padStart(2, '0')} / ${monthNames[date.getMonth()]} / ${date.getFullYear()}`;
  }
}
